var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-brand"},[_vm._v("Borderless.")]),_c('div',{staticClass:"footer-right"},[_c('span',[_vm._v("1 CAD ≈ 0.74 USD + 5% Fees")])])])
}]

export { render, staticRenderFns }